// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-iam-access-dialog-access-list__blocks {
  margin-top: 24px;
}
.dl-iam-access-dialog-access-list__block {
  margin-top: 12px;
}
.dl-iam-access-dialog-access-list__block:first-child {
  margin-top: 0;
}
.dl-iam-access-dialog-access-list__btn-retry {
  display: flex;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/IamAccessDialog/AccessList/AccessList.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;AAAR;AAGI;EACI,gBAAA;AADR;AAGQ;EACI,aAAA;AADZ;AAKI;EACI,aAAA;EACA,uBAAA;AAHR","sourcesContent":[".dl-iam-access-dialog-access-list__blocks {\n  margin-top: 24px;\n}\n.dl-iam-access-dialog-access-list__block {\n  margin-top: 12px;\n}\n.dl-iam-access-dialog-access-list__block:first-child {\n  margin-top: 0;\n}\n.dl-iam-access-dialog-access-list__btn-retry {\n  display: flex;\n  justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
